import { Address } from '../types/search.types'

export const formatAddress = (address: Address | undefined): string[] => {
  if (!address) return ['', '']

  // Check if street already starts with the number to avoid duplication
  let street = address.street || ''
  if (address.number && address.street) {
    const numberStr = address.number.toString().trim()
    const streetTrimmed = address.street.trim()
    // Only prepend number if street doesn't already start with it
    if (!streetTrimmed.startsWith(numberStr)) {
      street = `${numberStr} ${streetTrimmed}`
    }
  }

  const locality = address.postcode && address.locality
    ? `${address.postcode} ${address.locality}`
    : (address.locality || '')

  return [street, locality]
}

export const formatPrice = (price: number | undefined): string => {
  if (!price || price === 0) return ''
  return new Intl.NumberFormat('fr-BE', {
    style: 'currency',
    currency: 'EUR'
  }).format(price)
}

export const getStatusColor = (status: string | undefined): string => {
  if (!status) return 'default'
  const statusLower = status.toLowerCase().trim()
  
  if (statusLower.includes('terminé') || statusLower.includes('archive') || statusLower.includes('fini')) {
    return 'success'
  }
  if (statusLower.includes('cours') || statusLower.includes('actif') || statusLower.includes('visite')) {
    return 'active'
  }
  if (statusLower.includes('attente') || statusLower.includes('relecture') || statusLower.includes('planifier')) {
    return 'warning'
  }
  return 'pending'
}

export const getCategory = (typeMission: string | undefined): string => {
  if (!typeMission) return 'expertise'
  const type = typeMission.toLowerCase()
  if (type.includes('peb')) return 'peb'
  if (type.includes('permis')) return 'rentalPermit'
  return 'expertise'
}

export const getCompletionPercentage = (status: string | undefined): number => {
  if (!status) return 0
  
  const statusLower = status.toLowerCase().trim()
  const statusMapping: Record<string, number> = {
    'bureau à encoder': 10,
    'bureau a encoder': 10,
    'bureau à planifier': 20,
    'bureau a planifier': 20,
    'rv en attente 1° contact': 20,
    'rv en attente 2° contact': 20,
    'rv en attente 3° contact': 20,
    'expert à visiter': 30,
    'expert a visiter': 30,
    'expert à achever': 40,
    'expert a achever': 40,
    'attente doc/infos': 50,
    'attente documents/infos': 50,
    'attente doc infos': 50,
    'attente paiement client': 50,
    'attente paiement courtier': 50,
    'bureau à valoriser': 60,
    'bureau a valoriser': 60,
    'bureau à achever': 60,
    'bureau a achever': 60,
    'attente confirmation courtier': 70,
    'attente confirmation client': 70,
    'à transmettre': 80,
    'a transmettre': 80,
    'archives': 100,
    'archive': 100,
    'demande annulée': 100,
    'demande annulee': 100,
    'sans suite': 100,
    'terminé': 100
  }

  if (statusMapping[statusLower] !== undefined) {
    return statusMapping[statusLower]
  }
  
  // Try partial matches
  for (const [key, percentage] of Object.entries(statusMapping)) {
    if (statusLower.includes(key.split(' ')[0])) {
      return percentage
    }
  }
  
  return 25
}